<template>
  <!--
      作者 gmshop
      时间：2012-12-5
      描述：设置-设置
  -->
  <div class="product-add" v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px" v-if="!loading">
      <!--添加门店-->
      <div class="common-form">奖励设置</div>
      <el-form-item label="是否开启奖励：">
        <el-radio-group v-model="form.is_open" :rules="[{required: true,message: ' '}]">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="平均分红用户等级">
        <el-select v-model="form.mean_grade_ids" multiple style="width: 400px;" placeholder="请选择">
          <el-option
            v-for="item in grade_list"
            :key="item.grade_id"
            :label="item.name"
            :value="item.grade_id">
          </el-option>
        </el-select>
        <div class="gray9"> 说明：不选择则无法发放奖励 </div>
      </el-form-item>
      <el-form-item label="平均分红设置：">
        <div class="d-s-c">
          <span>平台营业额的</span>
          <el-input v-model="form.mean_ratio" type="number" style="width: 160px;margin-left: 10px;"></el-input>
          <span class="ml10">% x</span>
          <el-input v-model="form.mean_second_ratio" type="number" style="width: 160px;margin-left: 10px;"></el-input>
          <span class="ml10">% ÷ 总人数</span>
        </div>
      </el-form-item>

      <el-form-item label="贡献值分红用户等级">
        <el-select v-model="form.contribution_grade_ids" multiple style="width: 400px;" placeholder="请选择">
          <el-option
            v-for="item in grade_list"
            :key="item.grade_id"
            :label="item.name"
            :value="item.grade_id">
          </el-option>
        </el-select>
        <div class="gray9"> 说明：不选择则无法发放奖励 </div>
      </el-form-item>
      <el-form-item label="贡献值分红设置：">
        <div class="d-s-c">
          <span>平台营业额的</span>
          <el-input v-model="form.contribution_ratio" type="number" style="width: 160px;margin-left: 10px;"></el-input>
          <span class="ml10">% x</span>
          <el-input v-model="form.contribution_second_ratio" type="number" style="width: 160px;margin-left: 10px;"></el-input>
          <span class="ml10">% x (团队业绩÷平台总业绩)</span>
        </div>
      </el-form-item>

    <div style="clear: both; height: 100px;width: 100rpx;"></div>


      <!-- region_agent -->
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

</template>

<script>
  import PartnerApi from '@/api/partner.js';
  import { formatModel } from '@/utils/base.js';
  export default {
    components:{},
    data() {
      return {
        /*是否正在加载*/
        loading: true,
        /*form表单数据*/
        form: {
          is_open: 0,
          mean_grade_ids: '',
          mean_ratio: '',
          mean_second_ratio: '',
          contribution_grade_ids: '',
          contribution_ratio: '',
          contribution_second_ratio: '',
        },
        grade_list: [],
      };
    },
    created() {
      this.getParams()
    },

    methods: {

      /*获取配置数据*/
      getParams() {
        let self = this;
        PartnerApi.getSetting({}, true)
          .then(res => {
            let vars = res.data.setting;
            self.form = formatModel(self.form, vars);
            self.form.is_open = vars.is_open || self.form.is_open;
            self.form.mean_grade_ids = vars.mean_grade_ids || self.form.mean_grade_ids;
            self.form.mean_ratio = vars.mean_ratio || self.form.mean_ratio;
            self.form.mean_second_ratio = vars.mean_second_ratio || self.form.mean_second_ratio;
            self.form.contribution_grade_ids = vars.contribution_grade_ids || self.form.contribution_grade_ids;
            self.form.contribution_ratio = vars.contribution_ratio || self.form.contribution_ratio;
            self.form.contribution_second_ratio = vars.contribution_second_ratio || self.form.contribution_second_ratio;

            self.grade_list = res.data.grade_list;
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });
      },

      /*转JSON字符串*/
      convertJson(list) {
        let obj = {};

        list.forEach(item => {
          obj[item.grade_id] = item.award;
        });

        return JSON.stringify(obj);
      },

      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            PartnerApi.saveSetting(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，设置成功',
                  type: 'success'
                });
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },
      //监听复选框选中
      handleCheckedGetLog(e) {

      },
    }

  };
</script>
<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/partner/setting/index.vue